import { useReduxState } from 'hooks';
import { getAttributeConditionsString } from 'lib/customAttributes';
import { Badge, Tooltip } from 'components/common';

import type { AttributeCondition, UserCustomAttribute } from 'shared-types';

interface Props {
  conditions?: AttributeCondition[];
  text: string;
  userCustomAttributes: UserCustomAttribute[];
}

const UserAttributesPermissionsBadge = ({
  conditions,
  text,
  userCustomAttributes
}: Props) => {
  const { language, messages, theme } = useReduxState();

  const userCustomAttributesByKey = {};
  userCustomAttributes.forEach((availableAttribute) => {
    userCustomAttributesByKey[availableAttribute.key] = availableAttribute;
  });

  return (
    <Badge
      key={text}
      size="small"
      text={
        <div style={{ display: 'flex' }}>
          <div className="text">{text}</div>

          {conditions?.length ? (
            <Tooltip
              content={getAttributeConditionsString({
                conditions,
                language,
                messages,
                userCustomAttributesByKey
              })}
            >
              <div
                style={{
                  alignItems: 'center',
                  backgroundColor: 'white',
                  borderRadius: 20,
                  color: theme.textColorLight,
                  display: 'flex',
                  flexShrink: 0,
                  fontSize: '1.1rem',
                  justifyContent: 'center',
                  position: 'relative',
                  left: 5,
                  height: 14,
                  width: 14
                }}
              >
                {conditions.length}
              </div>
            </Tooltip>
          ) : null}
        </div>
      }
    />
  );
};

export default UserAttributesPermissionsBadge;
